<p-panel header="{{'fs.res.publication.creators.contacts.fieldset.header' | hisUi}}">
	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<div *ngIf="publication?.publicationType">
        <div *ngIf="noInternalPersonAssigned()" class="infoMessage">{{'fs.res.publication.creators.contacts.fieldset.noPerson.hint' | hisUi}}</div>
        <div *ngIf="!noInternalPersonAssigned()" class="infoMessage">{{'fs.res.publication.creators.contacts.fieldset.hint' | hisUi}}</div>
        <button *ngIf="!noInternalPersonAssigned()" [disabled]="disableAddContactBtn()" (click)="addContact()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.publication.creators.contacts.addContact' | hisUi}}</span></button>
        <div *ngIf="!noInternalPersonAssigned() && getCreatorContactFromPublication().length > 0">
            <p-table [value]="getCreatorContactFromPublication()">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngIf="!isHidden('fs.res.publication.PublicationContact.publicationCreator')">{{'fs.res.publication.creators.contacts.person.lastname' | hisUi}}</th>
                        <th *ngIf="!isHidden('fs.res.publication.PublicationContact.publicationCreator')">{{'fs.res.publication.creators.contacts.person.firstname' | hisUi}}</th>
                        <th *ngIf="!isHidden('fs.res.publication.PublicationContact.email')">{{'fs.res.publication.creators.contacts.email' | hisUi}}</th>
                        <th>{{'common.actions' | hisUi}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-creatorContact let-index="rowIndex" let-columns="columns">
                    <tr>
                        <td *ngIf="!isHidden('fs.res.publication.PublicationContact.publicationCreator')">{{creatorContact.person?.surname}}</td>
                        <td *ngIf="!isHidden('fs.res.publication.PublicationContact.publicationCreator')">{{creatorContact.person?.firstname}}</td>
                        <td *ngIf="!isHidden('fs.res.publication.PublicationContact.email')">{{creatorContact.email}}</td>
                        <td class="singleLine">
                            <button (click)="editContact(creatorContact)" hisImage="PENCIL" class="icon"
                                title="{{'common.editOf'|hisUi:(creatorContact.person?.firstname + ' ' + creatorContact.person?.surname)}}">
                            </button>
                            <button (click)="deleteContact(creatorContact)" hisImage="DELETE" class="icon"
                                title="{{'common.deleteOf'|hisUi:(creatorContact.person?.firstname + ' ' + creatorContact.person?.surname)}}">
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>
</p-panel>
<res-publication-contact-dialog *ngIf="contactDialogVisibility" [(visibility)]="contactDialogVisibility"
    [publication]="publication" [creator]="creator" (creatorChange)="creatorChange($event)">
</res-publication-contact-dialog>
